<template>
	<carousel class="index-carousel" :autoplay="true" :minSwipeDistance="40" :scrollPerPage="true" :speed="500"
		:perPage="1"  :loop="true" :navigationEnabled="false" paginationPosition="bottom-overlay" ><!-- :paginationPadding="10" :paginationSize="10" -->
<!-- 		 <slide>
		      Slide 1 Content
		    </slide>
		    <slide>
		      Slide 2 Content
		    </slide> -->
<!-- 		<slide class="items-carousel" v-for="(item,index) in bitems">
			<div style="width:100%">
				<a :href="item.url" class="item"><img :src="item.target" alt="" style="width:100%"></a>
			</div>
		</slide> -->
		<slide class="items-carousel" v-for="(item,index) in items" :key="index">
			<!-- {{  item }} -->
			<div style="width:100%">
				<a :href="item.hrefUrl" class="item"><img :src="$util.fixProtocol(item.fileUri)" alt="" style="width:100%"></a>
			</div>
		</slide>
	</carousel>
</template>

<script>
	import {
		Carousel,
		Slide
	} from 'vue-carousel'
	export default {
		props:['items'],
		components: {
			Carousel,
			Slide
		},
		mounted(){
		//   debugger
		},
		data() {
			return {
				bitems:[]
			}
		}
	}
</script>

<style scoped="scoped">

</style>